import { useState, useEffect, useContext } from "react";
import { get_tiptap_test_data, get_tiptap_doc } from '../../../../services/projectservice.js';
import TipTapEditor from "./TipTapEditor";
import { AuthContext } from '../../../../AuthContext.jsx';

export default function TextEditor() {

    const tiptapdoc = '902d1aaa-8cfd-4bd4-831e-db0e0660b21c'
  const { authToken, claims, isLoading, onLogout } = useContext(AuthContext);

    const [ editorContent, setEditorContent ] = useState('');
    const [ loadError, setLoadError ] =  useState(''); 

    const handleLoad = (data) => {
        setEditorContent(data.data); 
    }

    const handleLoadError = (error) => {
        console.error("Error loading data:", error);
        setLoadError(`Error loading data: ${error}`);
    }

    useEffect(() => {
        // get_tiptap_test_data(handleLoad, handleLoadError)
        get_tiptap_doc(tiptapdoc, authToken, handleLoad, handleLoadError)
    }, []);

    return (
        <div>
            <h1>Text Editor</h1>
            <p>This is a placeholder for the text editor component.</p>
            { editorContent && <TipTapEditor initialContent={editorContent}  doc_id={tiptapdoc} /> }
            { loadError && <div style={{ color: 'red' }}>{loadError}</div>  }
        </div>
    );
}
